import ExcelJS from "exceljs";
import excelSupporter from "@/excelSupporter.js";

const list = {
  // =================================================================================================================
  components() {
    return [
      {
        'component': 'search-start-end',
        "label": '평가일',
        "value": 'date',
        "query": {'ss': 'startDate', 'ee': 'endDate'},
        "options": {
          default: {sd: '', ed: ''},
        }
      },
      {'component': 'search-disaster-types', "label": '재해형태', "value": 'disaster', "query": {'dty': 'disaster'}, "options": {}},
      {
        'component': 'search-column-keyword',
        "label": '검색조건',
        "value": 'column',
        "query": {'ck_t': 'head', 'ck_k': 'keyword'},
        "options": {hiddenList: ['재해형태', '평가일']}
      },
    ]
  },
  getConditions: (nav) => {
    const conditions = [];
    const search = nav.value;

    //  평가일
    if (search.date) {
      conditions.push({key: 'body.inputB_4', operator: '>=', value: search.date.startDate})
      conditions.push({key: 'body.inputB_4', operator: '<', value: search.date.endDate ? new Date(search.date.endDate).addDays(1).format("yyyy-MM-dd") : ''})
    }

    //  재해형태
    if (search.disaster) {
      conditions.push({key: 'body.riskAppraisalList[%].input_3', operator: 'LIKE', value: `%${search.disaster}%`})
    }

    //  검색조건
    const heads = list.getHead().map(e => { return {[e.name] : e.key} });
    // 배열의 객체들을 하나의 객체로 합치기
    const types = Object.assign({}, ...heads);
    if (search.column && search.column.keyword) {
      conditions.push({key: types[search.column.head], operator: 'LIKE', value: `%${search.column.keyword}%`})
    }
    return conditions;
  },


  // =================================================================================================================
  getHead: () => {
    return [
      {
        "name": "회사명",
        "key": "body.stdInfo.field_name"
      },
      {
        "name": "공정명",
        "key": "body.inputB_2"
      },
      {
        "name": "작업내용",
        "key": "body.inputB_3"
      },
      {
        "name": "재해형태",
        "key": "body.disasters"
      },
      {
        "name": "평가일",
        "key": "body.inputB_4"
      },
      {
        "name": "소속명",
        "key": "body.stdInfo.department"
      },
      {
        "name": "부서명",
        "key": "body.stdInfo.com_name"
      },
      {
        "name": "작성자",
        "key": "body.stdInfo.writer_name"
      }
    ]
  },
  getCol: (index, value, func) => {
    try {
      // disasters 배열 중에서 중복된 항목을 제거한다
      const uniqueDisasters = [...new Set(func.getContent(value).riskAppraisalList.map(item => (item.input_3.indexOf('직접입력_') > -1) ? item.input_3.split('직접입력_')[1] : item.input_3))];
      // 오름차순 정렬
      uniqueDisasters.sort();


      switch (index) {
      case 0: return func.getContent(value).stdInfo.field_name // 사업장명
      case 1: return func.getContent(value).inputB_2 // 공정명
      case 2: return func.getContent(value).inputB_3 // 작업내용
      case 3: return uniqueDisasters.join(', ') // 재해형태
      case 4: return func.getContent(value).inputB_4 // 평가일
      case 5: return func.getContent(value).stdInfo.department // 소속명
      case 6: return func.getContent(value).stdInfo.section // 부서명
      case 7: return func.getContent(value).stdInfo.writer_name // 작성자
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {},
  getSearchKeyword: (nav) => {},

  // =================================================================================================================
  // 엑셀 다운로드 설정 (목록형 단일 시트 - 템플릿 파일 없이 코드에서 직접 생성)
  //  - 1행 헤더, 2행부터 "위험항목(riskAppraisalList) 1건당 1행"으로 채운다.
  //  - 문서 단위 정보(부서명/작성자/평가일/공정명/작업내용/실시기간)는 위험항목 행마다 반복 표기한다.
  //  컬럼: A 구분(빈값) / B 부서명(section) / C 작성자 / D 평가일 / E 공정명 / F 작업내용 / G 실시기간 /
  //        H 세부작업명 / I 평가구분·유해위험요인·재해형태 / J 현재안전보건조치 / K 현재위험가능성 /
  //        L 현재위험중대성 / M 위험도 / N 위험감소대책 / O 개선후위험도가능성 / P 개선후중대성 / Q 개선후위험도
  excelInfo: (dataList) => {
    const HEADER = [
      "구분", "부서명", "작성자", "평가일", "공정명", "작업내용", "실시기간", "세부작업명",
      "평가구분/유해·위험요인/재해형태", "현재안전보건조치", "현재 위험 가능성", "현재 위험 중대성",
      "위험도", "위험감소대책", "개선후 위험도 가능성", "개선 후 중대성", "개선후 위험도",
    ];
    const stripDirect = (v) => (v && `${v}`.indexOf("직접입력_") > -1 ? `${v}`.split("직접입력_")[1] : v || "");

    return {
      downloadFileName: "정기위험성평가",
      worksheetName: () => "정기위험성평가",
      singleSheet: (worksheet, posts) => {
        // 헤더 (1행)
        HEADER.forEach((h, ci) => {
          worksheet.getRow(1).getCell(ci + 1).value = h;
        });

        // 데이터 (2행부터)
        let rowIdx = 2;
        posts.forEach((post) => {
          let body = {};
          try {
            body = JSON.parse(post.post_content).body || {};
          } catch (e) { /* ignore */ }
          const std = body.stdInfo || {};

          const 부서명 = std.section || "";
          const 작성자 = std.writer_name || "";
          const 평가일 = body.inputB_4 || "";
          const 공정명 = body.inputB_2 || "";
          const 작업내용 = body.inputB_3 || "";
          const 실시기간 = body.inputB_8 || body.inputB_9 ? `${body.inputB_8 || ""} ~ ${body.inputB_9 || ""}` : "";

          const risks = Array.isArray(body.riskAppraisalList) ? body.riskAppraisalList : [];

          // 위험항목이 없는 문서도 한 줄로 표기한다.
          if (risks.length === 0) {
            const row = worksheet.getRow(rowIdx++);
            row.getCell(1).value = ""; // A 구분
            row.getCell(2).value = 부서명;
            row.getCell(3).value = 작성자;
            row.getCell(4).value = 평가일;
            row.getCell(5).value = 공정명;
            row.getCell(6).value = 작업내용;
            row.getCell(7).value = 실시기간;
            return;
          }

          risks.forEach((risk) => {
            const 평가구분유해재해 = [risk.input_2, risk.input_4, stripDirect(risk.input_3)]
              .filter((v) => v !== undefined && v !== null && `${v}` !== "")
              .join(" / ");
            const 현재위험도 = risk.input_6 && risk.input_7 ? Number(risk.input_6) * Number(risk.input_7) : "";
            const 개선후위험도 = risk.input_11 && risk.input_12 ? Number(risk.input_11) * Number(risk.input_12) : "";

            const row = worksheet.getRow(rowIdx++);
            row.getCell(1).value = ""; // A 구분 (빈값)
            row.getCell(2).value = 부서명; // B 부서명
            row.getCell(3).value = 작성자; // C 작성자
            row.getCell(4).value = 평가일; // D 평가일
            row.getCell(5).value = 공정명; // E 공정명
            row.getCell(6).value = 작업내용; // F 작업내용
            row.getCell(7).value = 실시기간; // G 실시기간
            row.getCell(8).value = risk.input_1 || ""; // H 세부작업명
            row.getCell(9).value = 평가구분유해재해; // I 평가구분/유해·위험요인/재해형태
            row.getCell(10).value = risk.input_5 || ""; // J 현재안전보건조치
            row.getCell(11).value = risk.input_6 || ""; // K 현재 위험 가능성
            row.getCell(12).value = risk.input_7 || ""; // L 현재 위험 중대성
            row.getCell(13).value = 현재위험도; // M 위험도
            row.getCell(14).value = risk.input_9 || ""; // N 위험감소대책
            row.getCell(15).value = risk.input_11 || ""; // O 개선후 위험도 가능성
            row.getCell(16).value = risk.input_12 || ""; // P 개선 후 중대성
            row.getCell(17).value = 개선후위험도; // Q 개선후 위험도
          });
        });
      },
    };
  },

  // 전체 다운로드(모든 문서 엑셀다운로드) - 새 워크북에 목록형으로 채운 뒤 다운로드
  customExcelDownload: async (dataList, title) => {
    const excelInfo = list.excelInfo(dataList);
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(excelInfo.worksheetName ? excelInfo.worksheetName() : "Sheet1");
    excelInfo.singleSheet(worksheet, dataList);
    await excelSupporter.workbookDownload(workbook, excelInfo.downloadFileName);
  },
}
export default list;
